import clsx from 'clsx';
import Icon from 'components/Icon';
import {FC} from 'react';

export type BooleanValue = {
    label: string;
    value: boolean;
};

export type BooleanGroupValueProps = {
    className?: string;
    hideDivider?: boolean;
    value: BooleanValue[];
};

const BooleanGroupValue: FC<BooleanGroupValueProps> = ({
    className,
    hideDivider,
    value,
}) => (
    <div
        className={clsx(
            'grid grid-cols-1',
            !hideDivider && 'gap-y-2',
            className,
        )}
    >
        {value.map((item) => (
            <div
                className={clsx(
                    'flex pb-2 text-grey-900',
                    !hideDivider && 'border-b border-grey-200',
                    className,
                )}
                key={item.label}
            >
                <Icon
                    className={clsx(
                        'p-1 text-grey-900',
                        item.label && 'flex-none',
                    )}
                    icon={item.value ? 'checkmark' : 'close'}
                    size="base"
                />
                <div>&nbsp;{item.label}</div>
            </div>
        ))}
    </div>
);

export default BooleanGroupValue;
